import { useRef, useEffect, useState, DependencyList } from 'react';

export const useElementResize = <T extends HTMLElement = HTMLDivElement>(deps: DependencyList = []) => {
  const [clientWidth, setClientWidth] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);

  const ref = useRef<T>(null);

  const onResize = () => {
    setClientWidth(ref.current?.clientWidth ?? 0);
    setClientHeight(ref.current?.clientHeight ?? 0);
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver(onResize);
    window.addEventListener('resize', onResize);

    if (ref.current) {
      onResize();
      resizeObserver.observe(ref.current);
    }
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', onResize);
    };
  }, deps);

  return { ref, clientWidth, clientHeight };
};
